import { BaseButton as BaseButton$1 } from './base-button.js';
import { BaseButtonLabel } from './base-button-label.js';
import { BaseButtonIcon } from './base-button-icon.js';
var BaseButton = Object.assign(BaseButton$1, {
  Label: BaseButtonLabel,
  Icon: BaseButtonIcon
});
export { BaseButton };